import capacitacionHome from '../../img/capacitacionHome.webp';
import { Link } from 'react-router-dom';
const Capacitacion = () => {
   return (
      <div className="section animated fadeIn" style={{ margin: '0px 0', padding: 0 }}>
         {/* BANNER INSTITUCIONAL DE CAPACITACIÓN - ANCHO COMPLETO */}
         <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', padding: '40px 30px', backgroundColor: '#039be5', margin: 0 }}>
            <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0, maxWidth: '1400px', marginLeft: 'auto', marginRight: 'auto' }}>
               {/* IMAGEN CIRCULAR CON MARCO ELEGANTE */}
               <div className="col s12 m12 l5 x5 center-align" style={{ marginBottom: '25px' }}>
                  <div style={{ display: 'inline-block', padding: '10px', background: 'rgba(255, 255, 255, 0.15)', borderRadius: '50%', boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}>
                     <img 
                        src={capacitacionHome} 
                        alt="Capacitación Online Latitud" 
                        className="circle responsive-img" 
                        style={{ width: '260px', height: '260px', objectFit: 'cover', border: '4px solid #ffffff', display: 'block' }} 
                     />
                  </div>
               </div>
               {/* TEXTO Y BOTÓN DE ACCIÓN */}
               <div className="col s12 m12 l7 x7 white-text center-on-small-only" style={{ paddingLeft: '20px' }}>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '8px', opacity: '0.9' }}>
                     Capacitación Continua
                  </span>
                  <h4 style={{ fontWeight: '700', fontSize: '2.1rem', margin: '0 0 12px 0', lineHeight: '1.3' }}>
                     Curso Online: Ergonomía y Prevención de Incendios
                  </h4>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.6', margin: '0 0 30px 0', fontWeight: '400', opacity: '0.95' }}>
                     Iniciá aquí la capacitación oficial y obtené tu certificado de aprobación.
                  </p>
                  <Link 
                     to={"prevencion"} 
                     className="btn waves-effect waves-light white grey-text text-darken-3 z-depth-1 hoverable" 
                     style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 32px', height: '46px', lineHeight: '46px' }}
                  >
                     Iniciar capacitación
                     <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>school</i>
                  </Link>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Capacitacion